import React, { Component, PropTypes as pt } from 'react';

class ModalFooter extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        let {
            cancelModal,
            saveAction,
            children,
            type
        } = this.props;

        const cancelButton = (typeof cancelModal === "function") ?
            <button className="btn btn-link" onClick={cancelModal}>
                Cancel
            </button> :
            cancelModal;

        return (!!children) ?
            (<div className="invintus-modal-footer">
                {!cancelModal ? cancelButton : null}
                {children}
            </div>) : (<div className="invintus-modal-footer">
                {cancelButton || null}
                {saveAction}
            </div>)
        ;
    }
}


ModalFooter.propTypes = {};

export default ModalFooter;
